import { baseUrl as apiBaseUrl } from '../config/appsettings';

const baseUrl = apiBaseUrl + 'common';

const CommonApiService = {

  // Get all notes
  getAllNotes: async () => {
    try {
      const response = await fetch(`${baseUrl}/notes`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching notes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  getNote: async () => {
    try {
      const response = await fetch(`${baseUrl}/note`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching notes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Get a single note by ID
  getNoteById: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/notes/${id}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Note not found');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Create a new note
  createNote: async (noteData) => {
    try {
      const response = await fetch(`${baseUrl}/notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(noteData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error creating note');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  // Delete a note by ID
  deleteNote: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/notes/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error deleting note');
      }

      return true; // Success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
  getAllNotifications: async () => {
    try {
      const response = await fetch(`${baseUrl}/notifications`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching notes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  getPublisherNotifications: async (publisherId) => {
    try {
      const response = await fetch(`${baseUrl}/notifications/publisher/${publisherId}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching notes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  updateNotifications: async (publisherId) => {
    try {
      const response = await fetch(`${baseUrl}/updatenotifications/publisher/${publisherId}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching notes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

};

export default CommonApiService;
